// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"wrapper___9tmXX","groups":"groups___2x-PZ","scroll":"scroll___1qVuX","bttn":"bttn___3q9km","active":"active___28Kdj","arrow":"arrow___RnPGH","disable":"disable___2QkpO"};